import { Component } from '@angular/core';
import { ProjectService } from 'src/app/Services/project.service';
import { TokenEncryptionService } from 'src/app/Services/token-encryption.service';
import { SharedService } from 'src/app/Services/sharedService';
import swal from 'sweetalert2';

@Component({
    selector: 'app-export-timesheet',
    templateUrl: './export-timesheet.component.html',
    styleUrl: './export-timesheet.component.css',
    standalone: false
})
export class ExportTimeSheetComponent {

  exportType: string = 'csv';
  teamsListForFilter: any = [];
  selectedTeam: any;
  isAdmin: boolean = false;
  isManager: boolean = false;
  startDate: Date;
  endDate: Date;
  minDate: Date;
  maxDate: Date;
  maxEndDate: Date;
  readonly MAX_DATE_RANGE_DAYS = 31;

  constructor(
    private _projectService: ProjectService, 
    private tokenEncryptionService: TokenEncryptionService,
    private _sharedService: SharedService
  ) { }

  ngOnInit(): void {
    this.setTimeRangeForDateInputs();
    const today = new Date();
    const currentMonth = today.getMonth();
    const currentYear = today.getFullYear();

    // Default date range: first day of current month to today
    this.startDate = new Date(currentYear, currentMonth, 1);
    this.endDate = today;
    this.updateMaxEndDate(this.startDate);

    this.checkUserRole();
    this.loadTeams();
  }

  setTimeRangeForDateInputs() {
    const user = this.tokenEncryptionService.getEncryptedItem<any>('user');
    const companyId = this.tokenEncryptionService.getEncryptedItem<any>('logedInUser')?.company_id ?? user?.company_id;
    const dateToUse = user?.meta?.today_date || new Date();
    this._sharedService.getValidationDateRangeByCompany(dateToUse, companyId).subscribe((range) => {
      this.maxDate = new Date(range.maxDate);
      this.minDate = new Date(range.minDate);
    });
  }

  loadTeams() {
    this._projectService.getTeamList().subscribe(
      (team: any) => {
        this.teamsListForFilter = team || [];
      },
      (err) => {
        console.error('Error loading teams:', err);
        this.teamsListForFilter = [];
      }
    );
  }

  teamSelectionChange() {
    // Handle team selection change if needed
  }

  teamSelected(team: any) {
    // Handle team selection if needed
  }

  onStartDateChange(event: any): void {
    const selected: Date = event.value;
    if (selected) {
      this.updateMaxEndDate(selected);
      if (this.endDate && this.endDate > this.maxEndDate) {
        this.endDate = null;
      }
    }
  }

  updateMaxEndDate(start: Date): void {
    const max = new Date(start);
    max.setDate(max.getDate() + this.MAX_DATE_RANGE_DAYS - 1);
    this.maxEndDate = max;
  }

  formatDate(date: Date): string {
    const d = String(date.getDate()).padStart(2, '0');
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const y = date.getFullYear();
    return `${y}-${m}-${d}`;
  }

  exportTimeSheet() {
    if (!this.startDate || !this.endDate) {
      swal.fire({ icon: 'warning', title: 'Invalid Date Range', text: 'Please select both start and end dates.' });
      return;
    }

    const diffDays = Math.round((new Date(this.endDate).getTime() - new Date(this.startDate).getTime()) / (1000 * 60 * 60 * 24)) + 1;
    if (diffDays > this.MAX_DATE_RANGE_DAYS) {
      swal.fire({ icon: 'warning', title: 'Date Range Too Large', text: `Please select a date range of ${this.MAX_DATE_RANGE_DAYS} days or less.` });
      return;
    }

    // Find selected team object to get team_id
    let teamId = null;
    if (this.selectedTeam && this.teamsListForFilter) {
      const selectedTeamObj = this.teamsListForFilter.find((team: any) => team.title.rendered === this.selectedTeam);
      teamId = selectedTeamObj ? selectedTeamObj.id : null;
    }

    const startDate = this.startDate ? this.formatDate(new Date(this.startDate)) : undefined;
    const endDate = this.endDate ? this.formatDate(new Date(this.endDate)) : undefined;

    this._projectService.getTimeSheetRecords(this.exportType, teamId, startDate, endDate).subscribe((response: any) => {
      if (response) {
        this.downloadCsvOnSuccess(response);
      }
    }, (error) => {
      let errorMessage = 'Data not exported due to technical issue, Please contact support';
      if (error && error.error && JSON.parse(error.error)) {
        let errJSONFormat = JSON.parse(error.error);
        errorMessage = errJSONFormat && errJSONFormat.message ? errJSONFormat.message : 'Data not exported due to technical issue, Please contact support';
      }
      swal.fire({
        icon: 'error',
        title: 'Export Unsuccessful!',
        text: errorMessage,
      })
    });
  }

  
  downloadCsvOnSuccess(response: string): void {
    const csvFileName = this.getReportFileName();
    const filename = `${csvFileName}.csv`;

    // Create a Blob from the CSV response
    const blob = new Blob([response], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);

    // Create a temporary anchor element to trigger the download
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();

    // Clean up
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }

  getReportFileName(): string {
    const now = new Date();
    const day = String(now.getDate()).padStart(2, '0');
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const year = now.getFullYear();
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    const timestamp = `${day}-${month}-${year}-${hours}:${minutes}:${seconds}`;
    return `Supersee-TimeSheet-${timestamp}`;
  }

  checkUserRole() {
    const user = this.tokenEncryptionService.getEncryptedItem<any>('user');
    console.log("under checkUserRole");
    console.log(user);
    if (user && user.role) {
      let roles = user.role;
      let adminRole = roles.filter((ele: any) => {
        return (ele.toLowerCase().includes("admin") || ele.toLowerCase().includes("company"));
      })
      console.log("Here is the admin role ", adminRole);
      if (adminRole.length == 0) {
        this.isAdmin = false;
      } else {
        this.isAdmin = true;
      }
      let managerRole = roles.filter((ele) => {
          return (ele.toLowerCase().includes("manager"));
      })
      if (managerRole.length == 0) {
        this.isManager = false;
      } else {
        this.isManager = true;
      }
    }
  }
}
